const initializeMegaMenuToggles = () => {
  document.querySelectorAll('[data-af-mega-menu]').forEach((menu) => {
    if (menu.dataset.megaMenuInitialized === 'true') return;

    menu.dataset.megaMenuInitialized = 'true';
    menu.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-mega-menu-toggle]');
      if (!toggle || !menu.contains(toggle)) return;

      const column = document.getElementById(toggle.dataset.columnId);
      if (!column) return;

      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      column.querySelectorAll('[data-mega-menu-extra]').forEach((item) => {
        item.hidden = expanded;
        item.classList.toggle('af-mega-menu__item--hidden', expanded);
      });
      toggle.setAttribute('aria-expanded', String(!expanded));
    });
  });
};

initializeMegaMenuToggles();
document.addEventListener('shopify:section:load', initializeMegaMenuToggles);
